import RessourceSelectorsFactory from 'helpers/RessourceSelectorsFactoryHelpers';
import {
    default as createActionCreator,
    HTTP_METHODS,
} from 'helpers/RessourceActionCreatorsFactoryHelpers';

/*
 * Configuration
 */

export const ressourceName = 'SUPPORT';

/*
 * Actions
 */

export const REQUEST_POST_SUPPORT = `REQUEST_POST_${ressourceName}`;
export const REQUEST_POST_SUPPORT_SUCCESS = `REQUEST_POST_${ressourceName}_SUCCESS`;
export const REQUEST_POST_SUPPORT_ERROR = `REQUEST_POST_${ressourceName}_ERROR`;

/*
 * Action Creators
 */

export const postSupport = createActionCreator({
    type: REQUEST_POST_SUPPORT,
    method: HTTP_METHODS.POST,
    url: '/support',
    withPagination: false,
});

/*
 * Selectors
 */
export const {
    getItemSelector,
    isLoadingSelector,
    getCountSelector,
    getPageSelector,
    getPageSizeSelector,
    getCurrentItemsSelector,
} = RessourceSelectorsFactory({
    reducerName: 'APISupport',
});
